var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"mr-1",attrs:{"color":_vm._f("getColorFromStatus")(_vm.status)}},on),[_vm._v(" "+_vm._s(_vm._f("getIconFromStatus")(_vm.status))+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }